import { Doughnut } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from "chart.js";
import { isColorDark } from "../config";

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = ({
    configData,
    data,
    animation = true,
    height
}) => {
    const labels = configData?.map(detail => detail?.label);
    const backgroundColor = configData?.map(detail => detail?.color);
    const values = data?.map((details) => Number(details) || 0) || [];
    const isAllZero = !values?.length || values?.every((details) => details === 0);

    const chartData = {
        labels: isAllZero
            ? ["No Data"]
            : labels,
        datasets: [
            {
                data: isAllZero ? [1] : values,
                backgroundColor: isAllZero ? ["#E0E0E0"] : backgroundColor,
                borderColor: isAllZero ? ["#E0E0E0"] : backgroundColor,
                borderWidth: 1,
                borderRadius: 6,
            },
        ],
    };
    const options = {
        animation: animation === false ? false : {},
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                color: (context) => {
                    const bgColor = context?.dataset?.backgroundColor?.[context?.dataIndex];
                    return isAllZero ? "#888888" : (isColorDark(bgColor) ? "#FFFFFF" : "#000000");
                },
                font: {
                    weight: "bold",
                    size: 14,
                },
                formatter: (value) => {
                    return isAllZero ? 0 : value;
                },
                display: (context) => {
                    return isAllZero || context?.dataset?.data?.[context?.dataIndex] > 0;
                },
                textStrokeColor: (context) => {
                    const bgColor = context?.dataset?.backgroundColor?.[context?.dataIndex];
                    return isColorDark(bgColor) ? "#000000" : "#FFFFFF";
                },
                textStrokeWidth: 1,
            },
            legend: {
                position: "bottom",
            },
            tooltip: {
                enabled: true,
                callbacks: {
                    label: (context) => {
                        if (isAllZero) {
                            return "0";
                        }
                        return context.formattedValue;
                    }
                }
            },
        },
    };
    return <>
        <div style={{ height: height || 220 }}>
            <Doughnut data={chartData} options={options} />
        </div>
    </>
};
export default DoughnutChart